import { Box } from '@mui/material'
import { ReactNode, useCallback } from 'react'
import { useStyles } from './styles'

interface IKanbanColumn {
  status: 'toDo' | 'initialized' | 'completed'
  children: ReactNode
}

const KanbanColumn = ({ status, children }: IKanbanColumn) => {
  const classes = useStyles()

  const changeStyleByStatus = useCallback(
    (status: IKanbanColumn['status']) => {
      switch (status) {
        case 'toDo':
          return classes.containerToDo
        case 'initialized':
          return classes.containerInitialized
        case 'completed':
          return classes.containerCompleted
        default:
          break
      }
    },
    [status]
  )

  return <Box className={changeStyleByStatus(status)}>{children}</Box>
}

export default KanbanColumn
